export enum Placement {
  default = 'default',
  absolute = 'absolute',
  fixed = 'fixed'
}
